{
  "sidenavMenuCloseTooltip": "Menü schließen",
  "sidenavMenuLockTooltip": "Zum Sperren des Menüs klicken",
  "toggleSideNav": "Seitliches Navigationsmenü ein/aus"
}
